import React from 'react';
import { CopyButton } from './CopyButton';

interface propsInterface {
  values: number[][],
  methods: {
    convertDECtoHEX: (decimal: number) => string
  }
}

export const ScaleStep = React.memo<propsInterface>((props) => {
  const updateTooltipTextColor = ((rgb: { r: number, g: number, b: number }) => {
    const tooltipColorNumber = Object.values(rgb).reduce((prev, current) => {
      return prev + current
    });
    if(tooltipColorNumber < (256 * 3) / 2) {
      return '#fff';
    } else {
      return '#000';
    }
  });
  return (
    <>
      <div className='p-app-scale-block'>
        <ul className='__scale-list'>
          {
            props.values.map((values, index) => {
              return (
                <li className='__scale-item' key={index} style={{ 
                  minWidth: `calc(100% / ${props.values.length})`,
                  backgroundColor: `rgb(${values[0]}, ${values[1]}, ${values[2]})`
                }}>
                  <span className='__scale-tip-wrap'>
                    <span className='__scale-tip' style={{
                      backgroundColor: `rgb(${values[0]}, ${values[1]}, ${values[2]})`,
                      color: updateTooltipTextColor({ 
                        r: values[0],
                        g: values[1],
                        b: values[2]
                      })
                    }}>
                      <span className='__code'>{`#${props.methods.convertDECtoHEX(values[0])}${props.methods.convertDECtoHEX(values[1])}${props.methods.convertDECtoHEX(values[2])}`}</span>
                      <span className='__code'>{`${values[0]}, ${values[1]}, ${values[2]}`}</span>
                      <CopyButton 
                        currentColor={
                          {
                            gradation: null,
                            hex: `#${props.methods.convertDECtoHEX(values[0])}${props.methods.convertDECtoHEX(values[1])}${props.methods.convertDECtoHEX(values[2])}`,
                            rgb: `rgb(${values[0]}, ${values[1]}, ${values[2]})`
                          }
                        } 
                        scaleType={'step'}
                      />
                    </span>
                  </span>
                </li>
              )
            })
          }
        </ul>
      </div>
    </>
  )
});